import React from "react";
import { CATEGORIES } from "../../data/destinations";

export const CategoryTabs = ({ active, onChange }) => {
  return (
    <div
      data-testid="category-tabs"
      className="flex flex-wrap items-center gap-2 md:gap-3"
    >
      {CATEGORIES.map((c) => {
        const isActive = c.id === active;
        return (
          <button
            key={c.id}
            data-testid={`category-tab-${c.id}`}
            onClick={() => onChange?.(c.id)}
            className={`tab-pill group relative inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-medium md:px-5 md:py-2.5 ${
              isActive
                ? "border-brand-ink bg-brand-ink text-white"
                : "border-brand-line bg-white text-brand-ink hover:border-brand-ink"
            }`}
          >
            <span
              className={`overline ${
                isActive ? "text-white/60" : "text-brand-inkSoft/60"
              }`}
              style={{ fontSize: "0.6rem" }}
            >
              {c.overline}
            </span>
            <span>{c.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default CategoryTabs;
